import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BaseService, Logger } from 'ngx-elvis-ds';
import { SAMService } from '../sam/sam.service';
import { SAMMessage } from '../sam/interfaces/sam-message';
import { ConfigService } from '../config.service';
import { LangMessages } from '../base/messages';
import { LocaleId } from '../locale.provider';
import { Declarations } from '../base/declarations';

export interface ICurrencyInfo {
  name: string;
  description: string;
  symbol: string;
  decimalsAmount?: number;
  divider?: number;
  digitsInfo?: string;
}
@Injectable({
  providedIn: 'root'
})
export class I18NService extends BaseService {

  private initialized = false;

  messages: {
    [key: string]: string
  } = {  };

  constructor(
    private sam: SAMService,
    private configSvc: ConfigService,
    @Inject(LOCALE_ID) public localeId: LocaleId,
  ) {
    super();
  }

  translate(key: string, ...args: string[]) {
    let message = ``;

    if (!this.messages[key]) {
      message = `!!${key} (L=${this.configSvc.language})`
      return message;
    } else {
      message = this.messages[key];
    }

    for (let i = 0; i < args.length; i++) {
      message = message.replace(`{@}`, args[i]);
    }

    return message;
  }

  setLanguage(lang: number) {
    if (lang) {
      this.configSvc.language = lang;
    }

    Logger.info(`[i18n] Setting Language ID ${this.configSvc.language}`);

    this.messages = { ...LangMessages.getMessages(this.configSvc.language) };
  }

  setCurrency(currency: ICurrencyInfo) {
    this.setDivider(currency);
    this.setDigitsInfo(currency);
    this.setDeclarations(currency);
    Logger.info(`[i18n] Setting Currency ${currency.name}, Description: ${currency.description}, Symbol: ${currency.symbol}, Decimals: ${currency.decimalsAmount}`);
    this.configSvc.currency = currency;
  }

  subscribeListeners() {
    if (this.initialized) {
      return;
    }

    this.messages = { ...LangMessages.getMessages(this.configSvc.language) };

    this.sam.channels.gui.subscribe((msg: SAMMessage) => {
      if (['SET_LANGUAGE'].includes(msg.Command)) {
        
        const data = msg.parms;

        if (data.language) {
          this.setLanguage(parseInt(data.language, 10));
        }

        if (data.currency) {
          this.setCurrency(data.currency);
        }

        if (data.messages) {
          this.messages = { ...LangMessages.getMessages(this.configSvc.language), ...data.messages };
        }
      }
    });
  }

  // private 
  private setDivider(currency: ICurrencyInfo) {
    try {
      currency.divider = 10 ** currency.decimalsAmount;
    } catch (error) {
      currency.divider = 1;
    }
  }

  private setDigitsInfo(currency: ICurrencyInfo) {
    switch (currency.decimalsAmount) {
      case 2:
        currency.digitsInfo = '1.2-2';
        break;
      default:
        currency.digitsInfo = `1.${currency.decimalsAmount || 0}-${currency.decimalsAmount || 0}`;
        break;
    }
  }

  private setDeclarations(currency: ICurrencyInfo) {
    const declarations = Declarations[currency.name];
    if (declarations) {
      this.configSvc.paymentSettings.paymentDeclarations = declarations;
    }
  }
}
